<div class=" ion-text-center question-headline question">
  <div [innerHTML]="model._headlineResolved" class="ion-text-center" [style.color]="model.color">
  </div> <!-- | safeHtml after headline -->
</div>
